/*
  remood-tracker.js — suivi du comportement sur le thème (fiches produits en priorité).
  N'EST PAS ENCORE DANS LE THÈME. Pour l'activer (après validation de Hassan) :
    1. copier ce fichier dans assets/remood-tracker.js ;
    2. dans layout/theme.liquid, avant </body>, ajouter (adresse du relais = réglage de thème, pas en dur) :
       {%- if settings.analytics_endpoint != blank -%}
         <script src="{{ 'remood-tracker.js' | asset_url }}" data-endpoint="{{ settings.analytics_endpoint }}" defer></script>
       {%- endif -%}
  Rien n'est envoyé tant que le visiteur n'a pas accepté la mesure d'audience
  (API Customer Privacy de Shopify : un seul bandeau, celui de Shopify).
  Aucune saisie (e-mail, adresse, texte tapé) n'est lue ni envoyée.
*/
(function () {
  'use strict';
  var script = document.currentScript;
  var ENDPOINT = script && script.dataset.endpoint;
  if (!ENDPOINT || window.__remoodTracker) return;
  window.__remoodTracker = true;

  var IDLE_MS = 30 * 60 * 1000;
  var MODAL_NAMES = { dims: 'Dimensions', info: 'Livraison et retours', reviews: 'Avis' };
  var queue = [];
  var allowed = false;
  var sid = null;
  var pageStart = Date.now();
  var maxScroll = 0;

  // ---------- Consentement (bandeau Shopify) ----------
  function consentOk() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
  }
  function onConsent() {
    if (allowed || !consentOk()) return;
    allowed = true;
    start();
  }
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) onConsent();
    });
  }
  document.addEventListener('visitorConsentCollected', onConsent);

  // ---------- Identifiants ----------
  function rid() {
    return (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
  }
  function sessionId() {
    try {
      var s = JSON.parse(localStorage.getItem('rm_an_s') || 'null');
      var now = Date.now();
      if (!s || now - s.last > IDLE_MS) s = { id: rid(), last: now, src: null };
      s.last = now;
      localStorage.setItem('rm_an_s', JSON.stringify(s));
      return s;
    } catch (e) {
      return { id: sid || rid(), last: Date.now(), src: null };
    }
  }
  function touch() {
    var s = sessionId();
    sid = s.id;
    return s;
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : undefined;
  }

  // ---------- Contexte de page ----------
  var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  var handleMatch = location.pathname.match(/\/products\/([^/?#]+)/);
  var h1 = document.querySelector('h1');
  var page = {
    path: location.pathname.slice(0, 500),
    template: (meta.page && meta.page.pageType) || undefined,
    product: handleMatch ? handleMatch[1] : undefined,
    product_title: handleMatch && h1 ? h1.textContent.trim().slice(0, 200) : undefined,
  };
  function device() {
    var w = window.innerWidth;
    return w < 768 ? 'mobile' : w < 1024 ? 'tablet' : 'desktop';
  }
  // Le support (utm_medium) distingue une pub payée du lien en bio : « instagram · pub », « instagram · bio ».
  var PAID = ['paid', 'cpc', 'ppc', 'ads', 'paid_social', 'paidsocial'];
  function source() {
    var q = new URLSearchParams(location.search);
    var utm = q.get('utm_source');
    if (utm) {
      var medium = (q.get('utm_medium') || '').toLowerCase();
      if (PAID.indexOf(medium) !== -1) medium = 'pub';
      return (utm.toLowerCase() + (medium ? ' · ' + medium : '')).slice(0, 60);
    }
    if (q.get('gclid')) return 'google ads';
    if (q.get('fbclid')) return 'facebook';
    if (!document.referrer) return 'direct';
    try {
      var host = new URL(document.referrer).hostname.replace(/^www\./, '');
      if (host === location.hostname.replace(/^www\./, '')) return null; // navigation interne
      var known = ['google', 'bing', 'instagram', 'facebook', 'pinterest', 'tiktok', 'youtube', 'linkedin', 'duckduckgo', 'qwant', 'ecosia'];
      for (var i = 0; i < known.length; i++) if (host.indexOf(known[i]) !== -1) return known[i];
      return host.slice(0, 60);
    } catch (e) {
      return 'inconnu';
    }
  }

  // ---------- Envoi ----------
  function track(type, data) {
    if (!allowed) return;
    touch();
    queue.push({ v: 1, sid: sid, cid: cookie('_shopify_y'), t: Date.now(), type: type, page: page, data: data || {} });
    if (queue.length >= 20) flush();
  }
  function flush() {
    if (!queue.length) return;
    var body = JSON.stringify({ events: queue.splice(0, 200) });
    // text/plain : pas de requête préalable CORS, et sendBeacon survit à la fermeture de l'onglet.
    var blob = new Blob([body], { type: 'text/plain' });
    if (!(navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob))) {
      fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, headers: { 'content-type': 'text/plain' } }).catch(function () {});
    }
  }

  // ---------- Libellé et section d'un élément ----------
  function label(el) {
    var t = el.getAttribute('data-track') || el.getAttribute('aria-label') || el.getAttribute('title') ||
      (el.textContent || '').replace(/\s+/g, ' ').trim() || (el.querySelector('img') && el.querySelector('img').alt) || el.tagName.toLowerCase();
    return t.slice(0, 80);
  }
  function sectionKey(el) {
    var s = el.closest && el.closest('.shopify-section');
    if (!s || !s.id) return undefined;
    var i = s.id.lastIndexOf('__');
    return i === -1 ? s.id.replace('shopify-section-', '') : s.id.slice(i + 2);
  }

  function start() {
    touch();
    var data = { device: device(), vw: window.innerWidth, vh: window.innerHeight, lang: document.documentElement.lang || '' };
    var src = source();
    if (src !== null) data.source = src;
    var q = new URLSearchParams(location.search);
    if (q.get('utm_campaign')) data.utm_campaign = q.get('utm_campaign').slice(0, 80);
    if (q.get('utm_content')) data.utm_content = q.get('utm_content').slice(0, 80);
    track('page_view', data);
    // Relie la visite au checkout : le pixel personnalisé reçoit ce numéro avec son propre clientId.
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('remood_visit', { sid: sid });
      }
    } catch (e) {}
    watchSections();
    watchScroll();
    watchClicks();
    watchProduct();
    watchCart();
    setInterval(flush, 10000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { closeSections(); flush(); }
    });
    window.addEventListener('pagehide', function () {
      closeSections();
      track('page_hide', { ms: Date.now() - pageStart, max_scroll: maxScroll });
      flush();
    });
  }

  // ---------- Sections vues et temps passé ----------
  var visible = {}; // clé -> début de la période visible
  function closeSections() {
    var now = Date.now();
    Object.keys(visible).forEach(function (k) {
      var ms = now - visible[k];
      if (ms >= 500) track('section_leave', { key: k, ms: ms });
      delete visible[k];
    });
  }
  function watchSections() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var now = Date.now();
      entries.forEach(function (e) {
        var key = sectionKey(e.target);
        if (!key) return;
        // Vue = la moitié de la section, ou 40 % de l'écran occupé par elle.
        var shown = e.isIntersecting && (e.intersectionRatio >= 0.5 || e.intersectionRect.height >= window.innerHeight * 0.4);
        if (shown && !(key in visible)) {
          visible[key] = now;
          track('section_view', { key: key });
        } else if (!shown && key in visible) {
          var ms = now - visible[key];
          delete visible[key];
          if (ms >= 500) track('section_leave', { key: key, ms: ms });
        }
      });
    }, { threshold: [0, 0.1, 0.25, 0.4, 0.5, 0.75] });
    document.querySelectorAll('main .shopify-section, #MainContent .shopify-section').forEach(function (el) { io.observe(el); });
  }

  // ---------- Profondeur de défilement ----------
  function watchScroll() {
    var marks = [25, 50, 75, 100];
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var doc = document.documentElement;
        var pct = Math.min(100, Math.round(((window.scrollY + window.innerHeight) / doc.scrollHeight) * 100));
        while (marks.length && pct >= marks[0]) {
          maxScroll = marks.shift();
          track('scroll_depth', { pct: maxScroll });
        }
      });
    }, { passive: true });
  }

  // ---------- Clics, clics répétés, fenêtres, accordéons ----------
  function watchClicks() {
    var last = { el: null, t: 0, n: 0, sent: false };
    // Un clic répété n'est « sans effet » que si rien n'a bougé depuis le clic précédent :
    // ni défilement (galeries, carrousels), ni changement dans la section (compteur, image, panneau).
    var moved = false;
    var mo = 'MutationObserver' in window ? new MutationObserver(function () { moved = true; }) : null;
    document.addEventListener('scroll', function () { moved = true; }, { capture: true, passive: true });
    function watchEffect(el) {
      moved = false;
      if (!mo) return;
      mo.disconnect();
      mo.observe((el.closest && el.closest('.shopify-section')) || document.body, { subtree: true, childList: true, attributes: true, characterData: true });
    }
    document.addEventListener('click', function (ev) {
      var el = ev.target.closest && ev.target.closest('a,button,summary,[role="button"],label,[data-track],[data-pmv6-thumb]');
      if (!el) return;
      var key = sectionKey(el);
      var now = Date.now();
      // Les accordéons et les vignettes réagissent à chaque clic : jamais comptés comme clics de rage.
      var toggles = el.tagName === 'SUMMARY' || el.hasAttribute('data-pmv6-thumb');
      if (!toggles && last.el === el && now - last.t < 1200) {
        if (moved) last.n = 1; // le clic précédent a eu un effet : on repart de zéro
        else last.n++;
        if (last.n >= 3 && !last.sent) { last.sent = true; track('rage_click', { label: label(el), count: last.n, key: key || null }); }
      } else {
        last = { el: el, t: now, n: 1, sent: false };
      }
      last.t = now;
      if (!toggles) watchEffect(el);
      var modal = el.getAttribute('data-pmv6-modal-open');
      if (modal) return track('modal_open', { title: MODAL_NAMES[modal] || modal });
      var thumb = el.getAttribute('data-pmv6-thumb');
      if (thumb !== null) return track('gallery', { index: Number(thumb), video: !!el.querySelector('.pmv6__thumb-play') });
      if (el.tagName === 'SUMMARY') { summaryClick = { el: el, t: now }; return; } // compté par l'événement toggle
      track('click', { label: label(el), key: key || null });
    }, true);
    // Seuls les accordéons ouverts ou fermés par le visiteur comptent : le thème en ouvre aussi par script
    // (colonnes du pied de page selon la largeur d'écran), ce n'est pas un geste du visiteur.
    var summaryClick = { el: null, t: 0 };
    document.addEventListener('toggle', function (ev) {
      var d = ev.target;
      if (!d || d.tagName !== 'DETAILS') return;
      var sum = summaryClick.el;
      if (!sum || sum.parentNode !== d || Date.now() - summaryClick.t > 1500) return;
      summaryClick.el = null;
      track('details_toggle', { title: sum ? label(sum) : 'détails', open: d.open, key: sectionKey(d) || null });
    }, true);
  }

  // ---------- Galerie (glissement), variantes ----------
  function watchProduct() {
    var track$ = document.querySelector('[data-pmv6-track]');
    if (track$) {
      var lastIdx = 0;
      var timer;
      track$.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var idx = Math.round(track$.scrollLeft / Math.max(1, track$.clientWidth));
          if (idx !== lastIdx) { lastIdx = idx; track('gallery', { index: idx }); }
        }, 250);
      }, { passive: true });
    }
    document.addEventListener('change', function (ev) {
      var el = ev.target;
      if (!el || !el.name || !/^(options|option|id$)/.test(el.name)) return;
      var form = el.form || document;
      var picked = Array.prototype.map.call(form.querySelectorAll('input[type="radio"]:checked, select'), function (x) {
        return x.tagName === 'SELECT' ? (x.options[x.selectedIndex] || {}).text : x.value;
      }).filter(Boolean).join(' / ');
      track('variant_change', { title: (picked || el.value || '').slice(0, 120) });
    }, true);
  }

  // ---------- Ajout au panier, ouverture du panier ----------
  function watchCart() {
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (url.indexOf('/cart/add') !== -1) {
          p.then(function (res) {
            if (!res.ok) return;
            res.clone().json().then(function (j) {
              var items = j.items || [j];
              items.forEach(function (it) {
                track('add_to_cart', {
                  product: it.handle || null,
                  variant_title: it.variant_title || null,
                  price: typeof it.final_price === 'number' ? it.final_price : (typeof it.price === 'number' ? it.price : null),
                  qty: it.quantity || 1,
                });
              });
              flush();
            }).catch(function () {});
          }).catch(function () {});
        }
        return p;
      };
    }
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && 'MutationObserver' in window) {
      var wasOpen = false;
      new MutationObserver(function () {
        var open = /\b(is-open|open|active)\b/.test(drawer.className) || drawer.getAttribute('aria-hidden') === 'false' || drawer.hasAttribute('open');
        if (open && !wasOpen) track('cart_open', {});
        wasOpen = open;
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
    }
  }
})();
